import { createSelector } from "reselect";
import { currentUserSelector } from "../current_user_selector";
import { securityRoleIds } from "src/constants/security_access";

/**
 * Memoized selector, returns true if user is a Swift Admin, false otherwise
 */

export const isRoleProviderSelector = createSelector(
  currentUserSelector,
  currentUser => {
    if (currentUser && currentUser.relationships.roles.data) {
      const userRoles = currentUser.relationships.roles.data.map(
        role => role.id
      );
      const providerRoles = [
        securityRoleIds.providerSwiftCode,
        securityRoleIds.remoteProvider
      ];
      return userRoles.some(userRole => providerRoles.includes(userRole));
    }
    return false;
  }
);
